import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { HemroLoadingBarComponent } from '@hemro/components/loading-bar/loading-bar.component';

@NgModule({
    declarations: [
        HemroLoadingBarComponent
    ],
    imports     : [
        CommonModule,
        MatProgressBarModule
    ],
    exports     : [
        HemroLoadingBarComponent
    ]
})
export class HemroLoadingBarModule
{
}
